const PREFIX = 'LIST'

export const LIST_GET_STATUS = `${PREFIX}_LOADING_STATUS`
export const LIST_GET_ERROR = `${PREFIX}_GET_ERROR`

export const LISTS_GET_META = `${PREFIX}S_GET`
export const LIST_GET = `${PREFIX}_GET`
export const LISTS_CLEAR = `${PREFIX}S_CLEAR`

export const SORT_TYPE = `${PREFIX}_SORT_TYPE`
